import { Logger } from "@devforce/trailhead-client-logger";
const logger = new Logger({
    prefix: "[@devforce/trailhead-client-api]: ",
});
const DEFAULT_INTERVAL = 3000;
const DEFAULT_RETRIES = 10;
export class PollingRequest {
    constructor({ request, done, interval, retries }) {
        // Internals
        this.resolve = () => { };
        this.reject = () => { };
        this.timer = null;
        this.attempt = 0;
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        this.request = request;
        this.done = done || (() => true);
        this.interval = interval || DEFAULT_INTERVAL;
        this.retries = retries || DEFAULT_RETRIES;
        this.start();
    }
    async then(onfulfilled, onrejected) {
        return this.promise.then(onfulfilled, onrejected);
    }
    async catch(onRejected) {
        return this.promise.catch(onRejected);
    }
    start() {
        this.poll().catch((e) => logger.warn(e.message));
    }
    stop() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.retries = 0;
        this.attempt = 0;
        this.timer = null;
    }
    async poll() {
        const currentAttempt = (this.attempt = this.attempt + 1);
        try {
            const res = await this.request();
            // If polling was stopped before the request could complete
            if (currentAttempt !== this.attempt)
                return;
            if (this.done(res)) {
                this.stop();
                this.resolve(res);
            }
            if (this.attempt < this.retries) {
                this.timer = setTimeout(() => {
                    this.poll().catch((e) => logger.warn(e.message));
                }, this.interval);
            }
            else {
                throw new Error("timeout");
            }
        }
        catch (err) {
            // If polling was stopped before the request could complete
            if (currentAttempt !== this.attempt)
                return;
            this.stop();
            this.reject(err);
        }
    }
}
